// import * as React from 'react';
// import { useState, useEffect } from 'react';
// import { IconButton, Switch, Box, TextField, Typography, Container, Button } from '@mui/material';
// import { GridToolbar, GridColDef } from '@mui/x-data-grid';
// import Grid from '@mui/material/Grid2';
// import AddIcon from '@mui/icons-material/Add';
// import VisibilityIcon from '@mui/icons-material/Visibility';
// import EditIcon from '@mui/icons-material/Edit';
// // import EditSquareIcon from '@mui/icons-material/EditSquare';

// import { useNavigate } from 'react-router-dom';
// import AddCardIcon from '@mui/icons-material/AddCard';
// import ImageIcon from '@mui/icons-material/Image';
// import {
// 	getSingleProductServices,
// 	updateProductStatusService,
// } from '../../../services/api/ProductAPI';
// import { StyledDataGrid } from '../../component/ThemeComponent';
// import ServiceProductForm from '../../../components/common/ServiceProduct';
// import { ServiceProduct } from 'types/serviceProduct';
// import ViewServiceProduct from '../../common/ViewServiceProduct';
// import PlanFieldDevelop from '../../common/PlanFieldDevelop';
// import ServiceProductCreate from '../../common/ServiceProductCreate';

// export interface ProductCardProps {
// 	_id: string;
// 	productName: string;
// 	serviceName: string;
// 	isPlanStructure: boolean;
// 	isFancyNumber: boolean;
// 	isDTH: boolean;
// 	status: number;
// 	createdAt: string;
// 	updatedAt: string;
// }

// const Vi: React.FC = () => {
// 	const [searchText, setSearchText] = useState<string>('');
// 	const [open, setOpen] = useState<boolean>(false);
// 	const [openViewModel, setOpenViewModel] = useState<boolean>(false);
// 	const [openPlanFieldModel, setOpenPlanFieldModel] = useState<boolean>(false);
// 	const [openServiceCreateModel, setOpenServiceCreateModel] = useState<boolean>(false);
// 	const [serviceProduct, setServiceProduct] = useState<ServiceProduct | undefined>(undefined);
// 	const [rows, setRows] = useState<ProductCardProps[]>([]);
// 	const [serviceIdSet, setServiceIdSet] = useState<string>('');
// 	const navigate = useNavigate();
// 	const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
// 		setSearchText(event.target.value);
// 	};

// 	const handleViewDetails = (service: ServiceProduct) => {
// 		setServiceProduct(service);
// 		setOpenViewModel(true);
// 	};
// 	const handlePlanFieldCreate = (service: ServiceProduct) => {
// 		setServiceProduct(service);
// 		setOpenPlanFieldModel(true);
// 	};
// 	const handlePlanFieldUpdate = (service: ServiceProduct) => {
// 		setServiceProduct(service);
// 		setOpenPlanFieldModel(true);
// 	};

// 	const handleEditDetails = (service: ServiceProduct) => {
// 		setServiceProduct(service);
// 		setOpen(true);
// 		setServiceIdSet(service._id);
// 	};

// 	const fetchdataorder = async () => {
// 		const response = await getSingleProductServices('Vi');
// 		if (response.success) {
// 			console.log(response);
// 			setRows(response.data);
// 		} else {
// 			console.error('Failed to fetch orders');
// 		}
// 	};

// 	const handleStatusChange = async (order: ProductCardProps) => {
// 		const updatedStatus = order.status === 1 ? 0 : 1;

// 		const formData = new FormData();
// 		formData.append('status', updatedStatus.toString());

// 		const response = await updateProductStatusService(formData, order._id);
// 		if (response) {
// 			console.log('Status updated successfully');
// 			setRows(
// 				rows.map((row) => (row._id === order._id ? { ...row, status: updatedStatus } : row))
// 			);
// 		} else {
// 			console.error('Failed to update status');
// 		}
// 	};

// 	useEffect(() => {
// 		fetchdataorder();
// 	}, []);

// 	useEffect(() => {
// 		window.scrollTo({
// 			top: 0,
// 			behavior: 'smooth',
// 		});
// 	}, []);

// 	const handleOpen = () => {
// 		setServiceProduct({
// 			_id: '',
// 			productName: 'Vi',
// 			serviceName: '',
// 			description: '',
// 			isPlanStructure: false,
// 			plans: {},
// 			textContent: { description: '', image: '' },
// 			isFancyNumber: false,
// 			isDTH: false,
// 			status: 0,
// 			createdAt: '',
// 			updatedAt: '',
// 		});
// 		setOpenServiceCreateModel(true);
// 	};

// 	const handleClose = () => {
// 		setOpen(false);
// 		setOpenViewModel(false);
// 		setOpenPlanFieldModel(false);
// 		setOpenServiceCreateModel(false);
// 	};

// 	const handleSuccess = () => {
// 		fetchdataorder(); // Refresh data after successful creation or update
// 	};

// 	const filteredRows = rows?.filter((row) =>
// 		row?.serviceName?.toLowerCase().includes(searchText.toLowerCase())
// 	);

// 	const columns: GridColDef[] = [
// 		{
// 			field: 'serviceName',
// 			headerName: 'Service Name',
// 			width: 250,
// 			renderCell: (params) => (
// 				<Button
// 					onClick={() =>
// 						navigate(`/${params.row.productName.toLowerCase()}/${params.row._id}`)
// 					}
// 					style={{ textTransform: 'none', color: '#000' }}
// 					variant="text"
// 				>
// 					{params.row.serviceName}
// 				</Button>
// 			),
// 		},
// 		{
// 			field: 'isFancyNumber',
// 			headerName: 'Fancy Number',
// 			width: 150,
// 			align: 'center',
// 			headerAlign: 'center',
// 		},
// 		{
// 			field: 'isDTH',
// 			headerName: 'DTH',
// 			width: 150,
// 			align: 'center',
// 			headerAlign: 'center',
// 		},
// 		{
// 			field: 'isPlanStructure',
// 			headerName: 'Service Structure Type',
// 			width: 150,
// 			align: 'center',
// 			headerAlign: 'center',
// 			renderCell: (params) => (
// 				<Box
// 					sx={{
// 						display: 'flex',
// 						alignItems: 'center',
// 						justifyContent: 'center',
// 						width: '100%',
// 						height: '100%',
// 					}}
// 				>
// 					<Typography>
// 						{params.row.isPlanStructure ? 'Plan Type' : 'Image Type'}
// 					</Typography>
// 				</Box>
// 			),
// 		},
// 		{
// 			field: 'status',
// 			headerName: 'Status',
// 			width: 100,
// 			type: 'string',
// 			renderCell: (params) => (
// 				<Switch
// 					checked={params.row.status === 1}
// 					onChange={() => handleStatusChange(params.row)}
// 				/>
// 			),
// 			align: 'center',
// 			headerAlign: 'center',
// 		},
// 		{
// 			field: '_id',
// 			headerName: 'Plan Field',
// 			width: 100,
// 			align: 'center',
// 			headerAlign: 'center',
// 			renderCell: (params) => (
// 				<>
// 					{params.row.isPlanStructure ? (
// 						params.row.plans && Object.keys(params.row.plans).length > 0 ? (
// 							<IconButton onClick={() => handlePlanFieldUpdate(params.row)}>
// 								<EditIcon />
// 							</IconButton>
// 						) : (
// 							<IconButton onClick={() => handlePlanFieldCreate(params.row)}>
// 								<AddCardIcon />
// 							</IconButton>
// 						)
// 					) : (
// 						<IconButton onClick={() => handleViewDetails(params.row)}>
// 							<ImageIcon />
// 						</IconButton>
// 					)}
// 				</>
// 			),
// 		},

// 		{
// 			field: 'actions',
// 			headerName: 'Actions',
// 			width: 200,
// 			align: 'center',
// 			headerAlign: 'center',
// 			renderCell: (params) => (
// 				<>
// 					<IconButton onClick={() => handleViewDetails(params.row)}>
// 						<VisibilityIcon />
// 					</IconButton>
// 					<IconButton onClick={() => handleEditDetails(params.row)}>
// 						<EditIcon />
// 					</IconButton>
// 				</>
// 			),
// 		},
// 	];

// 	return (
// 		<Container>
// 			<Box sx={{ width: '100%' }}>
// 				<div
// 					className="d-flex"
// 					style={{
// 						display: 'flex',
// 						justifyContent: 'space-between',
// 						alignItems: 'center',
// 					}}
// 				>
// 					<div style={{ width: '100%' }}>
// 						<Typography
// 							gutterBottom
// 							style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
// 							color="secondary"
// 						>
// 							Vi
// 						</Typography>
// 						<Typography
// 							className="d-flex"
// 							sx={{
// 								display: 'flex',
// 								justifyContent: 'space-between',
// 								alignItems: 'center',
// 								flexDirection: { xs: 'column', sm: 'row', md: 'row' },
// 								width: '100%',
// 							}}
// 						>
// 							<Typography
// 								style={{
// 									fontFamily: 'Poppins',
// 									fontWeight: '400',
// 									fontSize: '16px',
// 								}}
// 								color="secondary"
// 							>
// 								Manage your product, add new products, and more.
// 							</Typography>
// 							<Typography
// 								sx={{
// 									width: {
// 										xs: '100%',
// 									},
// 									flexBasis: { xs: 'auto', sm: 'content', md: 'content' },
// 								}}
// 							>
// 								<Button
// 									sx={{
// 										width: {
// 											xs: '100%',
// 											sm: 'auto',
// 											md: 'auto',
// 										},
// 									}}
// 									variant="contained"
// 									color="primary"
// 									onClick={handleOpen}
// 									startIcon={<AddIcon />}
// 								>
// 									Add Service
// 								</Button>
// 							</Typography>
// 						</Typography>
// 					</div>
// 				</div>
// 				<Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
// 					<Grid size={{ xs: 12, sm: 12, md: 12 }}>
// 						<TextField
// 							label="Search"
// 							variant="outlined"
// 							value={searchText}
// 							onChange={handleSearch}
// 							fullWidth
// 							style={{ fontFamily: 'Poppins' }}
// 							size="small"
// 							placeholder="Search by Service Name"
// 						/>
// 					</Grid>
// 				</Grid>
// 				<Box sx={{ height: 600, width: 'auto' }}>
// 					<StyledDataGrid
// 						rows={filteredRows}
// 						columns={columns}
// 						initialState={{
// 							pagination: {
// 								paginationModel: { pageSize: 10 },
// 							},
// 						}}
// 						pageSizeOptions={[10]}
// 						slots={{ toolbar: GridToolbar }}
// 						getRowId={(row) => row._id} // Specify custom id
// 					/>
// 				</Box>
// 			</Box>

// 			{serviceProduct && (
// 				<ServiceProductForm
// 					serviceProduct={serviceProduct}
// 					open={open}
// 					handleClose={handleClose}
// 					productNameProvide="Vi"
// 					onSuccess={handleSuccess} // Pass the callback function
// 					serviceId={serviceProduct._id || serviceIdSet || '000000'} // Pass the service
// 				/>
// 			)}

// 			<ServiceProductCreate
// 				open={openServiceCreateModel}
// 				handleClose={handleClose}
// 				productNameProvide="Vi"
// 				onSuccess={handleSuccess} // Pass the callback function
// 			/>

// 			<ViewServiceProduct
// 				serviceProduct={serviceProduct}
// 				open={openViewModel}
// 				handleClose={handleClose}
// 				productNameProvide="Vi"
// 			/>
// 			<PlanFieldDevelop
// 				serviceProduct={serviceProduct}
// 				open={openPlanFieldModel}
// 				handleClose={handleClose}
// 				productNameProvide="Vi"
// 				onSuccess={handleSuccess}
// 			/>
// 		</Container>
// 	);
// };

// export default Vi;
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
// =============================================================================================
import * as React from 'react';
import { useState, useEffect } from 'react';
import {
	IconButton,
	Switch,
	Box,
	TextField,
	Typography,
	Container,
	Button,
	Tooltip,
} from '@mui/material';
import { GridToolbar, GridColDef } from '@mui/x-data-grid';
import Grid from '@mui/material/Grid2';
import AddIcon from '@mui/icons-material/Add';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
// import EditSquareIcon from '@mui/icons-material/EditSquare';
import AddCardIcon from '@mui/icons-material/AddCard';
import ImageIcon from '@mui/icons-material/Image';
import { useNavigate } from 'react-router-dom';
import {
	getSingleProductServices,
	updateProductStatusService,
} from '../../../services/api/ProductAPI';
import { StyledDataGrid } from '../../component/ThemeComponent';
import ServiceProductForm from '../../../components/common/ServiceProduct';
import { ServiceProduct } from 'types/serviceProduct';
import ViewServiceProduct from '../../common/ViewServiceProduct';
import PlanFieldDevelop from '../../common/PlanFieldDevelop';
import ServiceProductCreate from '../../common/ServiceProductCreate';

export interface ProductCardProps {
	_id: string;
	productName: string;
	serviceName: string;
	isPlanStructure: boolean;
	isFancyNumber: boolean;
	isDTH: boolean;
	status: number;
	createdAt: string;
	updatedAt: string;
}

const Vi: React.FC = () => {
	const [searchText, setSearchText] = useState<string>('');
	const [open, setOpen] = useState<boolean>(false);
	const [openViewModel, setOpenViewModel] = useState<boolean>(false);
	const [openPlanFieldModel, setOpenPlanFieldModel] = useState<boolean>(false);
	const [openServiceCreateModel, setOpenServiceCreateModel] = useState<boolean>(false);
	const [serviceProduct, setServiceProduct] = useState<ServiceProduct | undefined>(undefined);
	const [rows, setRows] = useState<ProductCardProps[]>([]);
	const [serviceIdSet, setServiceIdSet] = useState<string>('');
	const navigate = useNavigate();

	const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
		setSearchText(event.target.value);
	};

	const handleViewDetails = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpenViewModel(true);
	};
	const handlePlanFieldCreate = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpenPlanFieldModel(true);
	};
	const handlePlanFieldUpdate = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpenPlanFieldModel(true);
	};

	const handleEditDetails = (service: ServiceProduct) => {
		setServiceProduct(service);
		setOpen(true);
		setServiceIdSet(service._id);
	};

	const fetchdataorder = async () => {
		const response = await getSingleProductServices('Vi');
		if (response.success) {
			console.log(response);
			setRows(response.data);
		} else {
			console.error('Failed to fetch orders');
		}
	};

	// const handleStatusChange = async (order: ProductCardProps) => {
	// 	const updatedStatus = order.status === 1 ? 0 : 1;
	// 	const response = await updateProductStatusService(order._id, updatedStatus);
	// 	if (response) {
	// 		console.log('Status updated successfully');
	// 		setRows(
	// 			rows.map((row) => (row._id === order._id ? { ...row, status: updatedStatus } : row))
	// 		);
	// 	} else {
	// 		console.error('Failed to update status');
	// 	}
	// };
	const handleStatusChange = async (order: ProductCardProps) => {
		const updatedStatus = order.status === 1 ? 0 : 1;

		const formData = new FormData();
		formData.append('status', updatedStatus.toString());

		const response = await updateProductStatusService(formData, order._id);
		if (response) {
			console.log('Status updated successfully');
			setRows(
				rows.map((row) => (row._id === order._id ? { ...row, status: updatedStatus } : row))
			);
		} else {
			console.error('Failed to update status');
		}
	};

	useEffect(() => {
		fetchdataorder();
	}, []);

	useEffect(() => {
		window.scrollTo({
			top: 0,
			behavior: 'smooth',
		});
	}, []);

	const handleOpen = () => {
		setServiceProduct({
			_id: '',
			productName: 'Vi',
			serviceName: '',
			description: '',
			isPlanStructure: false,
			plans: {},
			textContent: { description: '', image: '' },
			isFancyNumber: false,
			isDTH: false,
			status: 0,
			createdAt: '',
			updatedAt: '',
		});
		setOpenServiceCreateModel(true);
	};

	const handleClose = () => {
		setOpen(false);
		setOpenViewModel(false);
		setOpenPlanFieldModel(false);
		setOpenServiceCreateModel(false);
	};

	const handleSuccess = () => {
		fetchdataorder(); // Refresh data after successful creation or update
	};

	const filteredRows = rows?.filter((row) =>
		row?.serviceName?.toLowerCase().includes(searchText.toLowerCase())
	);

	const columns: GridColDef[] = [
		{
			field: 'serviceName',
			headerName: 'Service Name',
			width: 250,
			renderCell: (params) => (
				<Button
					onClick={() =>
						navigate(`/${params.row.productName.toLowerCase()}/${params.row._id}`)
					}
					style={{ textTransform: 'none', color: '#000' }}
					variant="text"
				>
					{params.row.serviceName}
				</Button>
			),
		},
		{
			field: 'isFancyNumber',
			headerName: 'Fancy Number',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'isDTH',
			headerName: 'DTH',
			width: 150,
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: 'isPlanStructure',
			headerName: 'Service Structure Type',
			width: 150,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<Box
					sx={{
						display: 'flex',
						alignItems: 'center',
						justifyContent: 'center',
						width: '100%',
						height: '100%',
					}}
				>
					<Typography>
						{params.row.isPlanStructure ? 'Plan Type' : 'Image Type'}
					</Typography>
				</Box>
			),
		},
		{
			field: 'status',
			headerName: 'Status',
			width: 100,
			type: 'string',
			renderCell: (params) => (
				<Switch
					checked={params.row.status === 1}
					onChange={() => handleStatusChange(params.row)}
				/>
			),
			align: 'center',
			headerAlign: 'center',
		},
		{
			field: '_id',
			headerName: 'Plan Field',
			width: 100,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<>
					{params.row.isPlanStructure ? (
						params.row.plans && Object.keys(params.row.plans).length > 0 ? (
							<Tooltip title="Edit Plan Field">
								<IconButton onClick={() => handlePlanFieldUpdate(params.row)}>
									<EditIcon />
								</IconButton>
							</Tooltip>
						) : (
							<Tooltip title="Create Plan Field">
								<IconButton onClick={() => handlePlanFieldCreate(params.row)}>
									<AddCardIcon />
								</IconButton>
							</Tooltip>
						)
					) : (
						<Tooltip title="View service image">
							<IconButton onClick={() => handleViewDetails(params.row)}>
								<ImageIcon />
							</IconButton>
						</Tooltip>
					)}
				</>
			),
		},

		{
			field: 'actions',
			headerName: 'Actions',
			width: 200,
			align: 'center',
			headerAlign: 'center',
			renderCell: (params) => (
				<>
					<Tooltip title="View Service">
						<IconButton onClick={() => handleViewDetails(params.row)}>
							<VisibilityIcon />
						</IconButton>
					</Tooltip>
					<Tooltip title="Edit Service">
						<IconButton onClick={() => handleEditDetails(params.row)}>
							<EditIcon />
						</IconButton>
					</Tooltip>
				</>
			),
		},
	];

	return (
		<Container>
			<Box sx={{ width: '100%' }}>
				<div
					className="d-flex"
					style={{
						display: 'flex',
						justifyContent: 'space-between',
						alignItems: 'center',
					}}
				>
					<div style={{ width: '100%' }}>
						<Typography
							gutterBottom
							style={{ fontFamily: 'Poppins', fontWeight: '700', fontSize: '24px' }}
							color="secondary"
						>
							Vi
						</Typography>
						<Typography
							className="d-flex"
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								flexDirection: { xs: 'column', sm: 'row', md: 'row' },
								width: '100%',
							}}
						>
							<Typography
								style={{
									fontFamily: 'Poppins',
									fontWeight: '400',
									fontSize: '16px',
								}}
								color="secondary"
							>
								Manage your product, add new products, and more.
							</Typography>
							<Typography
								sx={{
									width: {
										xs: '100%',
									},
									flexBasis: { xs: 'auto', sm: 'content', md: 'content' },
								}}
							>
								<Button
									sx={{
										width: {
											xs: '100%',
											sm: 'auto',
											md: 'auto',
										},
									}}
									variant="contained"
									color="primary"
									onClick={handleOpen}
									startIcon={<AddIcon />}
								>
									Add Service
								</Button>
							</Typography>
						</Typography>
					</div>
				</div>
				<Grid container spacing={2} sx={{ mb: 2, mt: 2 }}>
					<Grid size={{ xs: 12, sm: 12, md: 12 }}>
						<TextField
							label="Search"
							variant="outlined"
							value={searchText}
							onChange={handleSearch}
							fullWidth
							style={{ fontFamily: 'Poppins' }}
							size="small"
							placeholder="Search by Service Name"
						/>
					</Grid>
				</Grid>
				<Box sx={{ height: 600, width: 'auto' }}>
					<StyledDataGrid
						rows={filteredRows}
						columns={columns}
						initialState={{
							pagination: {
								paginationModel: { pageSize: 10 },
							},
						}}
						pageSizeOptions={[10]}
						slots={{ toolbar: GridToolbar }}
						getRowId={(row) => row._id} // Specify custom id
					/>
				</Box>
			</Box>

			{serviceProduct && (
				<ServiceProductForm
					serviceProduct={serviceProduct}
					open={open}
					handleClose={handleClose}
					productNameProvide="Vi"
					onSuccess={handleSuccess} // Pass the callback function
					serviceId={serviceProduct._id || serviceIdSet || '000000'} // Pass the service
				/>
			)}
			<ServiceProductCreate
				open={openServiceCreateModel}
				handleClose={handleClose}
				productNameProvide="Vi"
				onSuccess={handleSuccess} // Pass the callback function
			/>

			<ViewServiceProduct
				serviceProduct={serviceProduct}
				open={openViewModel}
				handleClose={handleClose}
				productNameProvide="Vi"
			/>
			<PlanFieldDevelop
				serviceProduct={serviceProduct}
				open={openPlanFieldModel}
				handleClose={handleClose}
				productNameProvide="Vi"
				onSuccess={handleSuccess}
			/>
		</Container>
	);
};

export default Vi;
